<template>

  <div class="content-wrapper">
    <div class="content-header row">
      <div class="content-header-left col-md-9 col-12 mb-2">
        <Breadcrumb
          :name="usedFor == 'merchant'?'Merchant':'User'"
          bc1="App"
          bc2="Profile"
          bc3="Kyc Groups"
        ></Breadcrumb>
      </div>
      <div class="col-3">
        <div class="d-flex align-items-center justify-content-end">
          <button
            type="button"
            class="btn btn-gradient-danger btn-sm"
            @click="backTo"
          >
            <span class="text-nowrap">Back</span>
          </button>
        </div>
      </div>
      <div
        class="content-header-right text-md-right col-md-3 col-12 d-md-block d-none"
      >
      </div>
    </div>
    <div class="content-body">

      <section id="page-account-settings2">
        <div class="row">
          <!-- left menu section -->
          <div class="col-md-3 mb-2 mb-md-0">
            <ul class="nav nav-pills flex-column nav-left">
              <!-- general -->
              <li class="nav-item" v-for="(item,index) in kycGroupsList" @click="renderKycGroups(item,index)">
                <a class="nav-link" :class="currentTab == index?'active':''" :id="'account-pill-general_'+index"
                   data-toggle="pill" :href="'#account-pill-general_'+index" aria-expanded="true"
                   @click="updateRecord = false">
                  <feather type="arrow-right" class="font-medium-3 mr-1 font-weight-bolder"></feather
                  >
                  <span class="font-weight-bold">{{ item.name }}</span>
                </a>
              </li>

            </ul>
          </div>
          <!--/ left menu section -->

          <!-- right content section -->
          <div class="col-md-9">
            <div class="card">
              <div class="card-body" :class="(!addRecord && !updateRecord )?'p-0 pt-2 pb-2':''">
                <div class="tab-content">
                  <!-- general tab -->
                  <div role="tabpanel" v-for="(item,index) in kycGroupsList" class="tab-pane"
                       :class="currentTab == index?'active':''" :id="'account-pill-general_'+index"
                       :aria-labelledby="'account-pill-general_'+index" aria-expanded="true">

                    <div class="row" v-if="!addRecord && !updateRecord">
                      <div class="col-sm-12">
                        <h2 :class="(!addRecord && !updateRecord )?'p-2':''">{{ item.name + ' Group' }}</h2>
                      </div>
                      <div class="col-sm-12 d-flex justify-content-end" v-if="!addRecord && !updateRecord">
                        <button
                          type="button"
                          class="btn btn-primary mr-2"
                          @click="showAddRecordPage"
                        >
                          <AddButtonText name="Group" />
                        </button>
                      </div>

                    </div>
                    <form class="validate-form" v-show="addRecord">
                      <div class="row">
                        <h2 class="p-1">Add Fields</h2>
                        <!--                          <h2>{{item.name+' Group'}}</h2>-->
                      </div>
                      <div class="row">
                        <div class="col-sm-6 col-12 ">
                          <label>Name Of Group</label>
                          <div class="input-group  input-group-merge mb-1">
                            <input type="text" class="form-control" v-model="kycGroupsList[index]['KycMainGroupName']"/>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6 col-12 ">
                          <div class="custom-control custom-switch mb-1">
                            <input :id="item.name.replace(/ /g,'_')+'_kycGroupForApi_'+index" type="checkbox"
                                   class="custom-control-input" v-model="kycGroupsList[index]['KycGroupForApi']"/>
                            <label class="custom-control-label"
                                   :for="item.name.replace(/ /g,'_')+'_kycGroupForApi_'+index">
                              For Api
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-for="(fields,fieldsIndex) in item.fields">
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label
                              v-if="fields.type.type != 'checkbox' && fields.type.type != 'radio' ">{{
                                fields.name
                              }}</label>
                            <div
                              v-if="fields.type.type == 'email' || fields.type.type == 'text' || fields.type.type == 'password'"
                              class="input-group form-password-toggle input-group-merge mb-1">
                              <input :type="fields.type.type" class="form-control"
                                     v-model="item.fields[fieldsIndex]['value']"/>
                            </div>
                            <div class=" mb-1" v-else-if="fields.type.type == 'number'">
                              <input type="number" class="form-control" v-model="item.fields[fieldsIndex]['value']"/>
                            </div>
                            <div class="custom-control custom-switch mb-1" v-else-if="fields.type.type == 'checkbox'">
                              <input :id="fields.name.replace(/ /g,'_')+'_checkbox_'+fieldsIndex" type="checkbox"
                                     class="custom-control-input" v-model="item.fields[fieldsIndex]['value']"/>
                              <label class="custom-control-label"
                                     :for="fields.name.replace(/ /g,'_')+'_checkbox_'+fieldsIndex">
                                {{ fields.name }}
                              </label>
                            </div>
                            <div class="form-check" v-else-if="fields.type.type == 'radio'">
                              <input
                                class="form-check-input"
                                type="radio"
                                :id="fields.name.replace(/ /g,'_')+'_radio_'+fieldsIndex"
                                v-model="item.fields[fieldsIndex]['value']"
                                value="true"
                              />
                              <label class="form-check-label"
                                     :for="fields.name.replace(/ /g,'_')+'_radio_'+fieldsIndex">{{
                                  fields.name
                                }}</label>
                            </div>

                            <div class="custom-file" v-else-if="fields.type.type == 'file'">
                              <input type="file" :key="reRenderKey" name="filename"
                                     @change="onFileChanged($event, index,fieldsIndex)">
                              <!--                                                            <input-->
                              <!--                                                              class="custom-file-input"-->
                              <!--                                                              type="file"-->
                              <!--                                                              :id="fields.name.replace(/ /g,'_')+'_file_'+fieldsIndex"-->
                              <!--                                                              @change="onFileChanged($event, fields,fieldsIndex)"-->
                              <!--                                                            />-->
                              <!--                                                            <label class="custom-file-label" :ref="'_file_'+fields.id+'_'+fieldsIndex" :for="fields.name.replace(/ /g,'_')+'_file_'+fieldsIndex">Choose File</label>-->
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-12 justify-content-end d-flex">
                          <button type="button" class="btn btn-primary mr-1 d-flex mt-1"
                                  @click="saveFields(item,index)" :disabled="loader">
                            <Loader :loading="loader" :size="size"></Loader>
                            Save Settings
                          </button>
                        </div>
                      </div>
                    </form>

                    <form class="validate-form" v-show="updateRecord">
                      <div class="row">
                        <h2 class="p-1">Update Fields</h2>
                        <!--                          <h2 class="p-1">{{item.name+' Group'}}</h2>-->
                      </div>
                      <div class="row">
                        <div class="col-sm-6 col-12 ">
                          <label>Name Of Group</label>
                          <div class="input-group  input-group-merge mb-1">
                            <input type="text" class="form-control" v-model="userKycUpdateGroupName"/>
                          </div>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-sm-6 col-12 ">
                          <div class="custom-control custom-switch mb-1">
                            <input :id="item.name.replace(/ /g,'_')+'_kycGroupForApi_update_'+index" type="checkbox"
                                   :true-value="1" :false-value="0" class="custom-control-input"
                                   v-model="userKycUpdateGroupForApi"/>
                            <label class="custom-control-label"
                                   :for="item.name.replace(/ /g,'_')+'_kycGroupForApi_update_'+index">
                              For Api
                            </label>
                          </div>
                        </div>
                      </div>
                      <div class="row" v-for="(fields,fieldsIndex) in updateFieldData">
                        <div class="col-12 col-sm-6">
                          <div class="form-group">
                            <label
                              v-if="fields.field.type.type != 'checkbox' && fields.field.type.type != 'radio' ">{{
                                fields.field.name
                              }}</label>
                            <div
                              v-if="fields.field.type.type == 'email' || fields.field.type.type == 'text' || fields.field.type.type == 'password'"
                              class="input-group form-password-toggle input-group-merge mb-1">
                              <input :type="fields.field.type.type" class="form-control"
                                     v-model="updateFieldData[fieldsIndex]['value']"/>
                            </div>
                            <div class=" mb-1" v-else-if="fields.field.type.type == 'number'">
                              <input type="number" class="form-control"
                                     v-model="updateFieldData[fieldsIndex]['value']"/>
                            </div>
                            <div class="custom-control custom-switch mb-1"
                                 v-else-if="fields.field.type.type == 'checkbox'">
                              <input :id="fields.field.name.replace(/ /g,'_')+'_checkbox_update_'+index+'_'+fieldsIndex"
                                     type="checkbox"
                                     :true-value="1" :false-value="0" class="custom-control-input"
                                     v-model="updateFieldData[fieldsIndex]['value']"/>
                              <label class="custom-control-label"
                                     :for="fields.field.name.replace(/ /g,'_')+'_checkbox_update_'+index+'_'+fieldsIndex">
                                {{ fields.field.name }}
                              </label>
                            </div>
                            <div class="form-check" v-else-if="fields.field.type.type == 'radio'">
                              <input
                                class="form-check-input"
                                type="radio"
                                :id="fields.field.name.replace(/ /g,'_')+'_radio_update_'+index+'_'+fieldsIndex"
                                v-model="updateFieldData[fieldsIndex]['value']"
                                value="true"
                              />
                              <label class="form-check-label"
                                     :for="fields.field.name.replace(/ /g,'_')+'_radio_update_'+index+'_'+fieldsIndex">{{
                                  fields.field.name
                                }}</label>
                            </div>
                            <div v-else-if="fields.field.type.type == 'file'">
                              <div class="row" v-if="checkImage(attachementPath+'/'+uuid+'/'+fields.value)">
                                <div class="col-12">
                                  <img
                                    v-if="fields.value.split('.').pop() == 'pdf'"
                                    class="att-preview"
                                    width="50"
                                    height="50"
                                    :src="`${publicPath}app-assets/images/pages/pdf-flat.png`"
                                    :href="attachementPath+'/'+uuid+'/'+fields.value"
                                  />
                                  <img
                                    v-else
                                    class="att-preview"
                                    width="50"
                                    height="50"
                                    :src="attachementPath+'/'+uuid+'/'+fields.value"
                                  />
                                </div>
                              </div>
                              <div class="row" v-if="!checkImage(attachementPath+'/'+uuid+'/'+fields.value) && updateFieldData[fieldsIndex]['value'] != ''">
                                <div class="col-12">
                                  <a :href="attachementPath+'/'+uuid+'/'+fields.value"  target="_blank">
                                    <img
                                      width="50"
                                      height="50"
                                      :src="`${publicPath}app-assets/images/pages/file.png`"

                                    />
                                  </a>
                                </div>
                              </div>
<!--                              <a class="badge badge-light-primary badge-sm mt-1 mb-1"-->
<!--                                 target="_blank"-->
<!--                                 v-if="!checkImage(attachementPath+'/'+uuid+'/'+fields.value) && updateFieldData[fieldsIndex]['value'] != ''"-->
<!--                                 :href="attachementPath+'/'+uuid+'/'+fields.value">View Upload</a>-->
                              <a class="badge badge-light-danger badge-sm mt-1 mb-1 "
                                 v-show="updateFieldData[fieldsIndex]['value'] != ''" href="javascript:void(0)"
                                 @click="resetFile(index,fieldsIndex)">Remove</a>
                              <div class="custom-file">
                                <input type="file" :ref="'removeFile_'+index+'_'+fieldsIndex" :key="reRenderKey"
                                       name="filename" @change="onFileChanged($event, index,fieldsIndex,true)">
                                <!--                                                            <input-->
                                <!--                                                              class="custom-file-input"-->
                                <!--                                                              type="file"-->
                                <!--                                                              :id="fields.name.replace(/ /g,'_')+'_file_'+fieldsIndex"-->
                                <!--                                                              @change="onFileChanged($event, fields,fieldsIndex)"-->
                                <!--                                                            />-->
                                <!--                                                            <label class="custom-file-label" :ref="'_file_'+fields.id+'_'+fieldsIndex" :for="fields.name.replace(/ /g,'_')+'_file_'+fieldsIndex">Choose File</label>-->
                              </div>
                            </div>

                          </div>
                        </div>
                      </div>
                      <div class="row mt-1">
                        <div class="col-12 justify-content-end d-flex">
                          <button type="button" class="btn btn-primary mr-1 d-flex mt-1"
                                  @click="updateFields(item,index)" :disabled="loader">
                            <Loader :loading="loader" :size="size"></Loader>
                            Update Settings
                          </button>
                        </div>
                      </div>
                    </form>

                    <div class="" v-if="!addRecord && !updateRecord && currentTab == index ">
                      <div class="">
                        <CommonTable
                          :url="url"
                          :tableHeaderValues="tableHeaderValues"
                          :actions="actions"
                          :deleteActions="deleteActions"
                          :mutedData="mutedData"
                          :storageKey="storageKey"
                          :externalTotalRecord="externalTotalRecord"
                          :filteredData="filteredData"
                          :force="force"
                          :alterResponseData="alter"
                          @getFullResponse="getFullResponse"
                        />
                      </div>
                    </div>

                  </div>

                </div>
              </div>
            </div>
          </div>
          <!--/ right content section -->
        </div>
      </section>


    </div>
    <div v-show="loader" class="blockUI" style="display:none"></div>
    <div v-show="loader" class="blockUI blockOverlay"
         style="z-index: 1000; border: none; margin: 0px; padding: 0px; width: 100%; height: 100%; top: 0px; left: 0px; background-color: rgb(0, 0, 0); opacity: 0.5; cursor: wait; position: fixed;"></div>
    <div v-show="loader" class="blockUI blockMsg blockPage"
         style="z-index: 1011; position: fixed; padding: 0px; margin: 0px; width: 30%; top: 40%; left: 35%; text-align: center; color: rgb(255, 255, 255); border: 0px; background-color: transparent; cursor: wait;">
      <div class="d-flex justify-content-center align-items-center"><p class="mr-50 mb-0">Please wait while your request is being processed...</p>
        <div class="spinner-grow spinner-grow-sm text-white" role="status"></div>
      </div>
    </div>
  </div>
</template>

<script>

import axios from 'axios';
import AddButtonText from "@/components/common/buttons/AddButtonText.vue";

export default {
  props: ['usedFor'],
  components: {
    AddButtonText,
    axios
  },

  mounted() {
    localStorage.setItem("url", "v1/get-user-kyc-group");
    this.checkDataInStore('v1/get-user-kyc-group')
    if(this.usedFor == 'merchant'){
      var merchantProfileData = this.$store.getters.getByKey(
        "merchantProfileData"
      );
    }else{
      var merchantProfileData = this.$store.getters.getByKey(
        "userProfileData"
      );
    }

    this.userId = merchantProfileData.row.id
    this.uuid = merchantProfileData.row.uuid


    this.getGroups()

  },
  data() {
    return {
      alter: {
        alter: (value) => {
          // if(value){
          //   if(value.data){
          //     let temp = []
          //     value.data.forEach((eachArrayItem)=>{
          //
          //       eachArrayItem.kyc_details
          //
          //       temp.push(eachArrayItem)
          //     })
          //     value.data = temp
          //   }
          // }
          return value
        }
      },
      updateFieldData: [],
      KycDetailData: [],
      showKycDetailModal: false,
      size: "10px",
      userId: '',
      currentTab: 0,
      kycGroupsList: [],
      fieldsArray: [],
      loader: false,
      filteredData: {},
      url: "v1/get-user-kyc-group",
      storageKey: "userKycGroup",
      tableHeaderValues: [
        {
          title: "Name",
          valueKey: "name"
        },
        {
          title: "Code",
          valueKey: "code",
          html: true,
          alter: function (value) {
            var html = "";
            html = `<div class="badge badge-pill  badge-glow badge-light-primary">${value}</div>`;
            return html;
          }
        },
        {
          title: "For Api",
          valueKey: "for_api",
          html: true,
          alter: (value) => {
            if (value == 1) {
              return `<span class=" font-weight-bolder text-success">Yes</span>`
            } else {
              return `<span class=" font-weight-bolder text-danger">No</span>`
            }
          }
        },

      ],
      actions: [
        // {
        //   title: "Details",
        //   class: "btn-primary mt-1",
        //   cta: (row, index) => {
        //     this.showKycDetailModal = true;
        //     if (row.kyc_details) {
        //       this.transactionData = row.kyc_details;
        //     }
        //   }
        // },
        {
          title: "Update & Details",
          class: "btn-primary mt-1 ml-1",
          cta: (row, index) => {
            this.reRenderKey++
            this.updateRecord = true;
            this.addRecord = false;

            let tempIds = {}
            let tempKyc = row.kyc_details
            if (row.kyc_details) {
              this.userKycGroupId = row.id
              this.userKycUpdateGroupName = row.name
              this.userKycUpdateGroupForApi = row.for_api
              row.kyc_details.forEach((eachDetail) => {
                tempIds[eachDetail.kyc_group_field_id] = true
              })

              if (this.kycGroupsList[this.currentTab].fields) {
                this.kycGroupsList[this.currentTab].fields.forEach((eachArrayItem) => {

                  if (!(eachArrayItem.id in tempIds)) {
                    let tempObj = {
                      field: {
                        id: eachArrayItem.id,
                        name: eachArrayItem.name,
                        field_id: eachArrayItem.field_id,
                        type: eachArrayItem.type
                      },
                      kyc_group_field_id: eachArrayItem.id,
                      status: eachArrayItem.status,
                      value: ""
                    }

                    tempKyc.push(tempObj)

                  }
                })
              }

              this.updateFieldData = tempKyc
            } else {
              this.updateFieldData = []
            }

            setTimeout(() => {
              window.ezInit()
            }, 1000)


          }
        },
      ],
      deleteActions: [],
      mutedData: [],
      externalTotalRecord: "",
      addRecord: false,
      updateRecord: false,
      force: false,
      uuid: '',
      attachementPath: '',
      filesToAdd: [],
      userKycGroupId: '',
      userKycUpdateGroupName: '',
      userKycUpdateGroupForApi: '',
      reRenderKey: 1

    }
  },
  methods: {
    checkImage(url) {

      return (url.match(/\.(jpeg|jpg|gif|png|pdf)$/) != null);
    },
    resetFile(index, fieldsIndex) {
      let element = 'removeFile_' + index + '_' + fieldsIndex
      this.$refs[element][0].value = null
      this.updateFieldData[fieldsIndex].value = ''
    }
    ,
    downloadItem(url) {
      axios.get(url, {responseType: 'blob'})
        .then(response => {
          const blob = new Blob([response.data], {type: 'application/pdf'})
          const link = document.createElement('a')
          link.href = URL.createObjectURL(blob)
          link.download = 'kyc_file'
          link.click()
          URL.revokeObjectURL(link.href)
        }).catch(console.error)
    }
    ,
    showAddRecordPage() {
      this.reRenderKey++
      this.addRecord = true
    }
    ,
    getFullResponse(response) {
      if (typeof (response.fullResponse) != 'undefined') {
        let data = response.fullResponse
        this.attachementPath = data.attachementPath
      }
    }
    ,
    updateFields(item, index) {

      this.loader = true
      this.force = false

      let data = {
        name: this.userKycUpdateGroupName,
        forApi: this.userKycUpdateGroupForApi ? 1 : 0,
        kycGroupId: item.id,
        userKycGroupId: this.userKycGroupId,
        userId: this.userId,
        kycData: []
      }
      if (this.updateFieldData) {
        if (this.updateFieldData.length > 0) {
          this.updateFieldData.forEach(eachField => {
            let temp = {
              fieldId: eachField.kyc_group_field_id,
              value: eachField.value,
            }

            data.kycData.push(temp)

          })
        }
      }


      data.kycData = JSON.stringify(data.kycData)

      this.makeRequest("post", "v1/manage-user-kyc-group", data).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          // if (code == 200) {
          //   this.loader = false;
          //   this.force =true
          //   this.addRecord = false
          // } else {
          //   this.loader = false;
          // }
          this.addRecord = false
          this.updateRecord = false
          this.loader = false;
          setTimeout(() => {
            this.force = true
          }, 1000)
        }
      });


    }
    ,
    emptyFields() {
      let tempData = []
      if (this.kycGroupsList.length > 0) {
        this.kycGroupsList.forEach(eachitem => {
          eachitem['KycMainGroupName'] = ''
          eachitem['KycGroupForApi'] = false

          if (eachitem.fields) {
            if (eachitem.fields.length > 0) {
              eachitem.fields.forEach((eachField, eachFieldIndex) => {
                if (eachField.type.type == 'checkbox' || eachField.type.type == 'radio') {
                  eachitem.fields[eachFieldIndex]['value'] = false
                } else {
                  eachitem.fields[eachFieldIndex]['value'] = ''
                }

              })
            }
          }
          tempData.push(eachitem)
        })
        this.kycGroupsList = tempData

      }
    }
    ,
    saveFields(item, index) {

      this.loader = true
      this.force = false
      let data = {
        kycGroupId: item.id,
        name: item.KycMainGroupName,
        forApi: item.KycGroupForApi,
        userId: this.userId,
        kycData: []
      }
      if (item.fields) {
        if (item.fields.length > 0) {
          item.fields.forEach(eachField => {
            let temp = {
              fieldId: eachField.id,
              value: eachField.value,
            }

            data.kycData.push(temp)

          })
        }
      }


      data.kycData = JSON.stringify(data.kycData)

      this.makeRequest("post", "v1/manage-user-kyc-group", data).then(callResponse => {
        if (!callResponse.error) {
          let code = callResponse.response.data.code;
          // if (code == 200) {
          //   this.loader = false;
          //   this.force =true
          //   this.addRecord = false
          // } else {
          //   this.loader = false;
          // }
          this.addRecord = false
          this.loader = false;
          setTimeout(() => {
            this.force = true
            this.emptyFields()
          }, 1000)
        }
      });
    }
    ,
    renderKycGroups(item, index) {
      this.currentTab = index
      setTimeout(() => {
        this.filteredData = {
          kycGroupId: item.id,
          userId: this.userId,
        }
      }, 300)
    }
    ,
    onFileChanged: function (event, KycIndex, fieldsIndex, update = false) {
      let file = event.target.files[0]
      this.loader = true
      if (typeof (file) != 'undefined') {
        this.loading = true;

        var data = {
          uuid: this.uuid,
        }

        let attachment = new FormData();
        attachment.append("attachment", file);
        data.hasAttachment = attachment

        this.makeRequest('post', 'v1/upload-user-kyc-file', data, {}, false).then(callResponse => {

          if (!callResponse.error) {
            let code = callResponse.response.data.code;
            if (code == 200) {
              let data = callResponse.response.data.data
              // this.filesToAdd.push(this.attachementPath+'/'+this.uuid+'/'+data.name)
              // console.log(fields, fieldsIndex,'aaaaaaaaaaaaaaaaaa')
              if (update) {
                if (this.updateFieldData) {
                  if (this.updateFieldData.length > 0) {
                    this.updateFieldData[fieldsIndex].value = data.name
                  }
                }
              } else {
                this.kycGroupsList[KycIndex].fields[fieldsIndex].value = data.name
              }
              // this.filesToAdd.push(data.name)

            }
            this.loader = false
          }

        });

      }

    }
    ,
    pushDataToFieldsArray(item, index) {
      this.currentTab = index
      this.fieldsArray = item.fields
    }
    ,
    getGroups() {
      this.makeRequest('post', 'v1/get-kyc-group', {status: 1}, {}, false).then(callResponse => {

        if (!callResponse.error) {
          let code = callResponse.response.data.code;

          if (code == 200) {
            let data = callResponse.response.data.data
            if (data) {

              // this.kycGroupsList = data
              let tempData = []
              if (data.length > 0) {
                data.forEach(eachitem => {
                  eachitem['KycMainGroupName'] = ''
                  eachitem['KycGroupForApi'] = false

                  if (eachitem.fields) {
                    if (eachitem.fields.length > 0) {
                      eachitem.fields.forEach((eachField, eachFieldIndex) => {
                        if (eachField.type.type == 'checkbox' || eachField.type.type == 'radio') {
                          eachitem.fields[eachFieldIndex]['value'] = false
                        } else {
                          eachitem.fields[eachFieldIndex]['value'] = ''
                        }

                      })
                    }
                  }
                  tempData.push(eachitem)
                })
                this.kycGroupsList = tempData
                this.currentTab = 0
                this.filteredData = {
                  kycGroupId: this.kycGroupsList[0].id,
                  userId: this.userId,
                }
              }
            }

          }
        }

      });

    }
    ,
    backTo() {

      if (this.addRecord || this.updateRecord) {
        this.addRecord = false
        this.updateRecord = false
      } else {
        this.$emit('hideKycGroup')
      }
    }
    ,


  },
  watch: {
    currentTab(val) {

    }
  }

}
</script>
<style>

</style>



